import { createSlice } from '@reduxjs/toolkit';
import { RootState } from './store';

const initialState = '';

export const tenantSlugSlice = createSlice({
  name: 'tenantSlug',
  initialState,
  reducers: {
    setTenantSlug: (state, { payload: data }) => {
      return data;
    },
  },
});

// Action creators are generated for each case reducer function
export const { setTenantSlug } = tenantSlugSlice.actions;

export const getTenantSlug = (state: RootState) => state.tenantSlug;

export default tenantSlugSlice.reducer;
